import { render, staticRenderFns } from "./DepoimentsPartiners.vue?vue&type=template&id=3f9d26da&scoped=true"
import script from "./DepoimentsPartiners.vue?vue&type=script&lang=js"
export * from "./DepoimentsPartiners.vue?vue&type=script&lang=js"
import style0 from "./DepoimentsPartiners.vue?vue&type=style&index=0&id=3f9d26da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9d26da",
  null
  
)

export default component.exports